import { InjectionToken } from "@angular/core";
import { Domain } from "@app2/alert/constants";
import { FilterGroup } from "@app2/fraud/type-defs";

export const ALERT_INBOX_GROUPS_TOKEN = new InjectionToken<FilterGroup[]>("ALERT_INBOX_GROUPS_TOKEN");
export const ALERT_INBOX_MODES_TOKEN = new InjectionToken<FilterGroup[]>("ALERT_INBOX_MODES_TOKEN");
export const ALERT_INBOX_DROPDOWN_FILTER_TOKEN = new InjectionToken<FilterGroup[]>("ALERT_INBOX_DROPDOWN_FILTER_TOKEN");
export const PRODUCT_DOMAIN = new InjectionToken<Domain>("PRODUCT_DOMAIN");
